import { render, staticRenderFns } from "./NotificationLimitedCreatorApplicationApproved.vue?vue&type=template&id=ca6767ee&scoped=true&"
import script from "./NotificationLimitedCreatorApplicationApproved.vue?vue&type=script&lang=ts&"
export * from "./NotificationLimitedCreatorApplicationApproved.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationLimitedCreatorApplicationApproved.vue?vue&type=style&index=0&id=ca6767ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6767ee",
  null
  
)

export default component.exports